import CreatorProfile from "./CreatorProfile";

export default function MistyHazeProfile() {
  return (
    <CreatorProfile
      creatorId={9}
      categoryLabel="Ghost Operative"
      onlyMemberzSlug="mistyhaze"
      tags={["Action", "Mystery", "Refs Of ILL", "ISM", "Arkitekz"]}
    />
  );
}
